import React, { useState } from 'react'
import './MessageBox.css';

export default function MessageBox() {
    const [message, setMessage] = useState("");

    const handleSend = (e) => {
        _$_appMessage = e.target.value
        setMessage(e.target.value)
    };

    return (
        <div className="message-box">
            <input
                type="text"
                className="message-input"
                placeholder="Type a messages..."
                value={message}
                onChange={(e) => { handleSend(e) }}
            />
            <button className="send-button" onClick={handleSend}>
                Clear
            </button>
        </div>
    );
}
